import styled from "styled-components";
import { useState, useEffect } from "react";
import PrimaryButton from "../../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../../components/FormControls/SecondaryButton";
import NarrowGrid from "../../../../../components/NarrowGrid";
import FormStringInput from "../../../../../components/FormControls/FormStringInput";
import request from "../../../../../api/request";
import { NotificationManager } from 'react-notifications';

const StyledRegions = styled.div`
    margin-left: 30px;
`;

const WhiteBoard = styled.div`
    background-color: white;
    width: 750px;
    box-sizing: border-box;
    min-height: 460px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

function Regions(props) {

    const [loadedPage, setLoadedPage] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [regions, setRegions] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [selectedRegionId, setSelectedRegionId] = useState(null);
    const [isAddMode, setIsAddMode] = useState(false);
    const [gridColumns, setGridColumns] = useState([
        {id: 'Name', type: 'String', width: 150, textAlign: 'left'},
        {id: 'Code', type: 'String', width: 70, textAlign: 'center'},
    ]);
    const [gridData, setGridData] = useState({groups: [''], items: [[]]});
    const [regionCode, setRegionCode] = useState('');
    const [regionName, setRegionName] = useState('');
    const [needsValidation, setNeedsValidation] = useState(false);
    const [isAddingDuplicatedItem, setIsAddingDuplicatedItem] = useState(false);

    const onSelectGridItem = (item) => {
        setSelectedRegionId(item.Id);
        setSelectedRegion(item);
    }
    
    const fetchRegions = async (regionCodeToSelect) => {
        try {
            let itemList = [];

            const resp = (await request('database', 'fetchRegions'));
            if (resp.ok) {
                resp.data.map((item, index) => {
                    itemList.push(item);
                });
                setRegions(itemList);
                rebuildGridData(itemList, regionCodeToSelect);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch regions: ', e);
            return false;
        }
        return true;
    }

    const onDeleteRegion = async () => {
        if (selectedRegion) {
            setIsDeleting(true);
            let deleteData = {};
            deleteData.RegionCode = selectedRegion.RegionCode;

            const resp = (await request('database', 'deleteRegion', [deleteData]));
            if (resp.ok) {
                setSelectedRegion(null);
                setSelectedRegionId(null);
                fetchRegions();
                NotificationManager.success('Successfully deleted region');
            } else
            {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
            setIsDeleting(false);
        }
    }

    const onSaveChanges = async () => {
        if (isAddMode) { // adding new item
            if (regionName === '' || regionCode === '') {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                if (gridData.items[0].length > 0 && (gridData.items[0].find((itm) => itm.RegionCode.replace(/\s/g, '') === regionCode.replace(/\s/g, '')))) {
                    setIsAddingDuplicatedItem(true);
                } else {
                    setIsSaving(true);
                    let saveData = {};
                    saveData.RegionCode = regionCode;
                    saveData.RegionName = regionName;

                    const resp = (await request('database', 'createRegion', [saveData]));
                    if (resp.ok) {
                        fetchRegions(regionCode);
                        NotificationManager.success('Successfully added region');
                    } else
                    {
                        console.log(resp.data);
                        NotificationManager.error(resp.data);
                    }
                    setIsSaving(false);
                    setIsAddMode(false);
                }
            }
        } else {
            if (selectedRegion && regionCode === '') {
                setNeedsValidation(true);
            } else {
                setIsSaving(true);
                let saveData = {};
                saveData.RegionCode = regionCode;
                saveData.RegionName = regionName;

                const resp = (await request('database', 'updateRegion', [saveData]));
                if (resp.ok) {
                    fetchRegions(regionCode);
                    NotificationManager.success('Successfully updated region');
                } else
                {
                    console.log(resp.data);
                    NotificationManager.error(resp.data);
                }
                setIsSaving(false);
            }
        }
    }

    const rebuildGridData = (items, regionCodeToSelect) => {
        if (items && items.length > 0) {
            let itemList = [];
            items.map((item, index) => {
                let gridItem = {Id: index, Name: item.RegionName, Code: item.RegionCode, ...item};
                itemList.push(gridItem);
                if (regionCodeToSelect && item.RegionCode === regionCodeToSelect) {
                    setSelectedRegionId(index);
                    setSelectedRegion(gridItem);
                }
            });
            setGridData({groups: [''], items: [itemList]});
        }
    }

    useEffect(() => {
        if (!loadedPage) {
            props.setPageTitle('Regions');
            fetchRegions();
            setLoadedPage(true);
        }
    }, []);

    useEffect(() => {
        if (isAddMode) {
            setNeedsValidation(false);
            setRegionName('');
            setRegionCode('');
        } else if (selectedRegion) {
            setNeedsValidation(false);
            setRegionName(selectedRegion.RegionName);
            setRegionCode(selectedRegion.RegionCode);
        }
    }, [isAddMode]);

    useEffect(() => {
        if (selectedRegion) {
            setNeedsValidation(false);
            setRegionName(selectedRegion.RegionName);
            setRegionCode(selectedRegion.RegionCode);
        } else {
            setNeedsValidation(false);
            setRegionName('');
            setRegionCode('');
        }
    }, [selectedRegion]);

    useEffect(() => {
        setIsAddingDuplicatedItem(false);
        setNeedsValidation(false);
    }, [selectedRegion, isAddMode]);

    return (
        <StyledRegions>
            <WhiteBoard>
                <div style={{display:'flex'}}>
                    <div>
                        <NarrowGrid id='generaltables_regions_grid' gridColumns={gridColumns} gridData={gridData} disabled={isAddMode} itemIdToSelect={selectedRegionId} onSelectGridItem={onSelectGridItem} gridStyle={{width:220, height:350, marginTop:20}}></NarrowGrid>
                        <div style={{marginTop:20}}>
                            {selectedRegionId !== null && !isAddMode && <SecondaryButton caption='Delete' isLoading={isDeleting} onClick={() => onDeleteRegion()} style={{width:75, height:25}}></SecondaryButton>}
                            {isAddMode && <SecondaryButton caption='Cancel' onClick={() => setIsAddMode(false)} style={{width:75, height:25, float:'right'}}></SecondaryButton>}
                            {!isAddMode && <PrimaryButton caption='Create new' onClick={() => setIsAddMode(true)} style={{width:100, height:25, float:'right'}}></PrimaryButton>}
                        </div>
                    </div>
                    <div style={{marginLeft:30}}>
                        <FormStringInput label='Code' value={regionCode} onChange={(val) => setRegionCode(val)} inputStyle={{width:100, height:35}} validated={needsValidation && regionCode === '' ? false : undefined} disabled={!isAddMode} ></FormStringInput>
                        <FormStringInput label='Name' value={regionName} onChange={(val) => setRegionName(val)} inputStyle={{width:290, height:35}} validated={needsValidation && regionName === '' ? false : undefined} disabled={!isAddMode && !selectedRegion}></FormStringInput>
                    {isAddingDuplicatedItem && <div style={{marginTop:15, width:280, fontSize:12, fontWeight:700, color:'#dc3545'}}>* Code is duplicated.</div>}
                    </div>
                </div>
            </WhiteBoard>
            <div>
                <PrimaryButton caption={isAddMode ? 'Add region' : 'Save changes'} isLoading={isSaving} onClick={() => onSaveChanges()} disabled={isAddMode || selectedRegion ? false : true} style={{width:150, float:'right'}}></PrimaryButton>
            </div>
        </StyledRegions>
    )
}

export default Regions;